export { pulseRateBounds, pulseRate } from './pulse-rate';
export { spo2Scale1Bounds, spo2Scale1 } from './spo2-scale-1';
export { respirationRateBounds, respirationRate } from './respiration-rate';
export { spo2Scale2AirBounds, spo2Scale2Air } from './spo2-scale-2-air';
export { spo2Scale2OxygenBounds, spo2Scale2Oxygen } from './spo2-scale-2-oxygen';
export { systolicBloodPressureBounds, systolicBloodPressure } from './systolic-blood-pressure';
export { temperatureBounds, temperature } from './temperature';
export { news2Bounds, news2RiskScale } from './news2-risk';
//# sourceMappingURL=index.js.map